import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function RoleRoute({ children, roles, redirect }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-blue-900" /></div>;
  }
  if (!user) return <Navigate to={redirect} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={redirect} replace />;
  return children;
}
